<template>
  <sForm
    v-if="spr.managers && spr.managers.length"
    ref="addAgreeingForm"
    :data-qa="`${dataQa}`"
    :disabled="disabled"
    label-position="top"
    :model="mutableValue"
    :rules="rules">
    <transition-group
      class="px-0"
      name="s-zoom-in-center">
      <sFormItem
        v-for="(stageItem, stageIndex) in mutableValue.stages"
        :key="`stage-${stageIndex}`"
        :data-qa="`${dataQa}-item-${stageIndex}`"
        :prop="`stages[${stageIndex}]`">
        <CollapseBlock
          class="mb-2"
          :value="stageItem.activeStatus !== 'DONE'">
          <transition-group
            slot="title"
            class="stage-title"
            :class="[`is-${stageItem.activeStatus || 'new'}`, {'is-edit': stageItem.editObject}]"
            :data-qa="`${dataQa}-item-${stageIndex}-block-title`"
            name="s-zoom-in-center"
            tag="div">
            <StageAdditionalAgreementFormEdit
              v-if="stageItem.editObject"
              :key="`stage-${stageIndex}-title`"
              :data-qa="dataQa"
              :disabled="disabled"
              :index="stageIndex"
              :value="mutableValue.stages[stageIndex]"
              @set-state="val => setEditResult(stageIndex, val)"
              @update:value="val => updateStage(stageIndex, val)"/>
            <div
              v-else
              :key="`stage-${stageIndex}-title`"
              class="grid">
              <div
                class="my-auto"
                :data-qa="`${dataQa}-item-${stageIndex}-block-title`">
                {{ stageItem.title }}
              </div>
              <div
                v-if="stageItem.type === 'QUORUM'"
                class="font-size-14 grey--text"
                :data-qa="`${dataQa}-item-${stageIndex}-block-quorumCount`">
                {{ $t('Tenders.eventProp.quorum') }}: {{ stageItem.quorumCount }}
              </div>
            </div>
            <div
              v-if="!stageItem.editObject"
              :key="`stage-${stageIndex}-status`"
              style="padding-top: 3px;">
              <StatusChip
                v-if="stageItem.activeStatus"
                class="font-size-12 px-2 my-auto"
                :data-qa="`${dataQa}-item-${stageIndex}-block-title_stage`"
                :name="$t(`Automation.State.${stageItem.activeStatus}`)"
                :status="stageItem.activeStatus"/>
            </div>
            <sTooltip
              v-if="!stageItem.editObject"
              :key="`stage-${stageIndex}-type`"
              :border="false"
              :enterable="false"
              type="white">
              <div class="mt-1">
                <sIcon
                  key="stage-${stageIndex}-type"
                  class="my-auto"
                  :class="spr.typeStage[stageItem.type].iconClass"
                  :type="spr.typeStage[stageItem.type].icon"/>
              </div>
              <div
                slot="content"
                :data-qa="`${dataQa}-item-${stageIndex}-block_type-parallel-hint`"
                style="max-width: 280px;">
                <b>{{ $t(`Tenders.AgreementTypes.${stageItem.type}`) }}</b>
                <div>{{ $t(`Tenders.AgreementTypes.${stageItem.type}_Text`) }} </div>
              </div>
            </sTooltip>
            <sPopover
              v-if="!stageItem.editObject"
              :key="`stage-${stageIndex}-menu`"
              :ref="`stage-menu-${stageIndex}`"
              :open-delay="300"
              placement="bottom-end"
              trigger="click">
              <sButton
                slot="reference"
                data-qa="btn-authomation-card-menu"
                icon="menu"
                small
                type="text"/>
              <div
                class="menu"
                :data-qa="dataQa + '-menu'">
                <MenuItem
                  v-for="(menu_item, index) in menuList"
                  :key="index"
                  :data-qa="`menu-automation-${menu_item.icon}`"
                  :disabled="disabled || (menu_item.disabled && menu_item.disabled(stageIndex))"
                  :icon="menu_item.icon"
                  :label="menu_item.text"
                  @click="menu_item.click(stageIndex)"/>
              </div>
            </sPopover>
          </transition-group>
          <div>
            <div>
              {{ $t('Tenders.Conciliators') }}
            </div>
            <transition-group
              class="px-0"
              name="s-zoom-in-center"
              tag="ul">
              <li
                v-for="(contact, contactIndex) in agreements[stageIndex]"
                :key="`contact-${contact.contactId || `empty-${contactIndex}`}`"
                class="stage-contact"
                :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}`">
                <template
                  v-if="contact.edit">
                  <sSelect
                    class="mr-3"
                    :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_select-manager`"
                    :disabled="disabled"
                    filterable
                    :placeholder="$t('Common.Select')"
                    :value="mutableValue.stages[stageIndex].agreements[contactIndex].approverType === 'CONTACT_PERSON' ? 'CONTACT_PERSON' : mutableValue.stages[stageIndex].agreements[contactIndex].contactId"
                    @update:value="val => setContact(stageIndex, contactIndex, val)">
                    <sOption
                      v-if="mode === 'automation'"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_select-manager-CONTACT_PERSON`"
                      :label="$t('Tenders.TenderContactPerson')"
                      :value="'CONTACT_PERSON'"/>
                    <sOption
                      v-for="item in managers[stageIndex].list"
                      :key="`manager-${item.contactId}`"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_select-manager-${item.contactId}`"
                      :label="item.name"
                      :value="item.contactId"/>
                  </sSelect>
                  <div/>
                </template>
                <template
                  v-else>
                  <sTooltip
                    :border="false"
                    class="my-auto"
                    :disabled="!contact.contactProps.name"
                    :enterable="false"
                    placement="bottom-start"
                    trigger="hover"
                    type="white"
                    width="280">
                    <div
                      class="flex pointer">
                      <UserIcon
                        class="py-0 mr-2"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_name`"
                        :name="contact.contactProps.name || '-'"
                        size="28"/>
                      <span
                        class="text-decoration-underline my-auto">
                        {{ contact.contactProps.name }}</span>
                    </div>
                    <div
                      slot="content"
                      class="py-4 px-4">
                      <div class="mb-2">
                        {{ contact.contactProps.name }}
                      </div>
                      <div
                        class="mb-2"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_email`">
                        {{ contact.contactProps.email }}
                      </div>
                      <div
                        class="mb-2"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_phone`">
                        {{ contact.contactProps.phone }}
                      </div>
                    </div>
                  </sTooltip>

                  <StatusChip
                    v-if="contact.status"
                    :key="`contact-${contact.contactId}-status-${contact.status}`"
                    class="font-size-12 px-2 my-auto"
                    :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_status`"
                    :name="contact.statusTitle"
                    :status="contact.status"/>
                  <div
                    v-else
                    class="my-auto">
                    <sChip
                      :key="`contact-${contact.contactId}-status-none`"
                      background="var(--green_chosen_light)"
                      class="bold"
                      color="var(--black-color)"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_status-added`"
                      style="height: 24px; margin: auto 0;">
                      {{ $t('Tenders.Added') }}
                    </sChip>
                  </div>
                </template>
                <div
                  class="my-auto flex">
                  <sTooltip
                    :border="false"
                    :enterable="false"
                    type="white">
                    <div>
                      <sButton
                        :color="stageItem.activeStatus !== 'DONE' && contact.allowDisagree ? 'var(--black-color)' : 'grey'"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_allowDisagree-btn`"
                        :disabled="stageItem.activeStatus === 'DONE' || disabled || contact.status==='SUCCESS' || contact.status === 'CANCELED'"
                        icon="circle-line"
                        icon-class="s-svg-icon-rotate-45"
                        small
                        type="text"
                        @click="setAgreementValue(stageIndex, contactIndex, 'allowDisagree', !mutableValue.stages[stageIndex].agreements[contactIndex].allowDisagree)"/>
                    </div>
                    <div
                      slot="content"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_allowDisagree-hint`"
                      style="max-width: 280px;">
                      <b>{{ $t('Tenders.AllowDisagree') }}</b>
                      <div>{{ $t('Tenders.AllowDisagree_Text') }}</div>
                    </div>
                  </sTooltip>
                  <sTooltip
                    :border="false"
                    :enterable="false"
                    type="white">
                    <div>
                      <sButton
                        :color="stageItem.activeStatus !== 'DONE' && contact.editTenderWhileAgree ? 'var(--black-color)' : 'grey'"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_editTenderWhileAgree-btn`"
                        :disabled="stageItem.activeStatus === 'DONE' || disabled || contact.status==='SUCCESS' || contact.status === 'CANCELED'"
                        icon="edit"
                        small
                        type="text"
                        @click="setAgreementValue(stageIndex, contactIndex, 'editTenderWhileAgree', !mutableValue.stages[stageIndex].agreements[contactIndex].editTenderWhileAgree)"/>
                    </div>
                    <div
                      slot="content"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_editTenderWhileAgree-hint`"
                      style="max-width: 280px;">
                      <b>{{ $t('Tenders.EditTenderWhileAgree') }}</b>
                      <div>{{ $t('Tenders.EditTenderWhileAgree_Text') }}</div>
                    </div>
                  </sTooltip>
                  <sTooltip
                    :border="false"
                    :enterable="false"
                    type="white">
                    <div>
                      <sButton
                        :color="stageItem.activeStatus !== 'DONE' && contact.allowAddFilesOnAgree ? 'var(--black-color)' : 'grey'"
                        :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_allowAddFilesOnAgree-btn`"
                        :disabled="stageItem.activeStatus === 'DONE' || disabled || contact.status==='SUCCESS' || contact.status === 'CANCELED'"
                        icon="file-add"
                        small
                        type="text"
                        @click="setAgreementValue(stageIndex, contactIndex, 'allowAddFilesOnAgree', !mutableValue.stages[stageIndex].agreements[contactIndex].allowAddFilesOnAgree)"/>
                    </div>
                    <div
                      slot="content"
                      :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_allowAddFilesOnAgree-hint`"
                      style="max-width: 280px;">
                      <b>{{ $t('Tenders.AllowAddFilesOnAgree') }}</b>
                      <div>{{ $t('Tenders.AllowAddFilesOnAgree_Text') }}</div>
                    </div>
                  </sTooltip>
                  <sButton
                    :data-qa="`${dataQa}-item-${stageIndex}-block_conciliators-${contactIndex}_delete-acceptor`"
                    :disabled="contact.status === 'SUCCESS' || contact.status === 'CANCELED' || disabled"
                    icon="delete"
                    small
                    type="text"
                    @click="deleteContact(stageIndex, contactIndex)"/>
                </div>
              </li>
            </transition-group>
          </div>

          <sAlert
            v-if="managers[stageIndex].disableMessage"
            :data-qa="`${dataQa}-item-${stageIndex}-alert`"
            small>
            {{ managers[stageIndex].disableMessage }}
          </sAlert>
          <sButton
            v-else-if="stageItem.activeStatus !== 'DONE'"
            :data-qa="`${dataQa}-item-${stageIndex}-addedContact`"
            icon="plus"
            type="text"
            @click="addedContact(stageIndex)">
            {{ $t('Tenders.AddedMore') }}
          </sButton>
        </CollapseBlock>
      </sFormItem>
    </transition-group>
    <sButton
      :data-qa="`${dataQa}-addedStage`"
      :disabled="disabled"
      icon="plus"
      type="text"
      @click="addedStage">
      {{ $t('Tenders.AddedStage') }}
    </sButton>
    <sFormItem
      class="mt-5"
      prop="comment">
      <span
        slot="label"
        class="black--text h5-headline pb-3">{{ $t('Tenders.AgreementComment') }}</span>
      <sInput
        clearable
        :data-qa="`${dataQa}-comment`"
        :max-length="1500"
        max-rows="10"
        :placeholder="$t('Tenders.AgreementComment')"
        show-word-limit
        trim
        type="textarea"
        :value="mutableValue.comment"
        @update:value="val => setRootValue('comment', val)"/>
    </sFormItem>
    <sFormItem
      prop="moveTenderAfterAgreeSucceeded">
      <sTooltip
        v-if="!tariff || value.existMainAgree"
        :border="false"
        class="mr-2"
        :content="value.existMainAgree ? $t('Common.HintAfterAgreeSucceeded') : 'Заборонені дії по руху тендеру далі за відсутності тарифу'"
        :data-qa="`${dataQa}-hintAfterAgreeSucceeded`"
        type="white">
        <sIcon
          class="s-cell__validateIcon"
          type="info"/>
      </sTooltip>
      <sCheckbox
        class="block"
        :data-qa="`${dataQa}-moveTenderAfterAgreeSucceeded`"
        :disabled="!tariff || value.existMainAgree"
        :value="mutableValue.moveTenderAfterAgreeSucceeded"
        @input="val => setRootValue('moveTenderAfterAgreeSucceeded', val)">
        {{ $t('Tenders.TenderAfterAgree') }}
      </sCheckbox>
      <sCheckbox
        class="block mt-2"
        :data-qa="`${dataQa}-isCancelTenderAfterReject`"
        :disabled="!$can('cancel', 'Tender')"
        :value="mutableValue.isCancelTenderAfterReject"
        @input="val => setRootValue('isCancelTenderAfterReject', val)">
        {{ $t('Tenders.IsCancelTenderAfterReject') }}
      </sCheckbox>
    </sFormItem>
  </sForm>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import MenuItem from 'components/common/MenuItem.vue'
import CollapseBlock from 'components/common/CollapseBlock.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import StageAdditionalAgreementFormEdit from 'components/agreement/StageAdditionalAgreementFormEdit.vue'

const contactTemplate = {
  editTenderWhileAgree: false,
  allowAddFilesOnAgree: false,
  contactId: null,
  approverType: null,
  allowDisagree: false,
  edit: true,
}
const stageTemplate = {
  title: null,
  editObject: null,
  type: 'CONSISTENTLY',
  agreements: []
}

/**
 * Форма данных для стадийного согласования
 */
export default {
  name: 'StageAdditionalAgreementForm',
  data() {
    return {
      dataQa: 'stage-additional-agreement',
      spr: {
        typeStage: {
          PARALLEL: {key: 'PARALLEL', icon: 'column'},
          CONSISTENTLY: {key: 'CONSISTENTLY', icon: 'column', iconClass: 's-svg-icon-rotate-90'},
          QUORUM: {key: 'QUORUM', icon: 'persons'},
        },
        managers: [],
      },
      tariff: null,
      rules: {},
    }
  },
  methods: {
    setEditResult(stageIndex, value) {
      const result = this.$_.cloneDeep(this.mutableValue)
      if (value) {
        const editObject = result.stages[stageIndex].editObject
        if (editObject) {
          Object.assign(result.stages[stageIndex], editObject)
        }
      }
      result.stages[stageIndex].editObject = null
      this.mutableValue = result
    },
    updateStage(stageIndex, newStage) {
      const result = this.$_.cloneDeep(this.mutableValue)
      this.$set(result.stages, stageIndex, newStage)
      this.mutableValue = result
    },
    setRootValue(propField, value) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result[propField] = value
      this.mutableValue = result
    },
    setStageValue(stageIndex, propField, value) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages[stageIndex][propField] = value
      this.mutableValue = result
    },
    setAgreementValue(stageIndex, contactIndex, propField, value) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages[stageIndex].agreements[contactIndex][propField] = value
      this.mutableValue = result
    },
    /**
     * Устанавливаем значение согласованта
     */
    setContact(stageIndex, contactIndex, val) {
      const result = this.$_.cloneDeep(this.mutableValue)
      const agreement = result.stages[stageIndex].agreements[contactIndex]
      if (val === 'CONTACT_PERSON') {
        agreement.approverType = 'CONTACT_PERSON'
        agreement.contactId = null
      } else {
        agreement.approverType = null
        agreement.contactId = val
      }
      agreement.edit = false
      this.mutableValue = result
    },
    /**
     * переходим в режим изменения заголовка стадии
     */
    editTitleStage(stageIndex) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages[stageIndex].editObject = {
        title: this.mutableValue.stages[stageIndex].title,
        type: this.mutableValue.stages[stageIndex].type,
        quorumCount: this.mutableValue.stages[stageIndex].quorumCount,
      }
      this.mutableValue = result
    },
    /**
     * Удаляем согласованта
     */
    deleteContact(stageIndex, contactIndex) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages[stageIndex].agreements.splice(contactIndex, 1)
      if (!result.stages[stageIndex].agreements?.length) {
        result.stages[stageIndex].agreements.push(this.$_.cloneDeep(contactTemplate))
      }
      this.mutableValue = result
      this.createRules()
    },
    /**
     * Добавляем нового согласованта
     */
    addedContact(index) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages[index].agreements.push(this.$_.cloneDeep(contactTemplate))
      this.mutableValue = result
      this.createRules()
    },
    /**
     * Удаляем стадию
     */
    deleteStage(stageIndex) {
      const result = this.$_.cloneDeep(this.mutableValue)
      result.stages.splice(stageIndex, 1)
      this.mutableValue = result
      this.createRules()
    },
    /**
     * Добавляем стадию
     */
    addedStage() {
      const newStage = this.$_.cloneDeep(stageTemplate)
      newStage.title = this.$t('Tenders.StageTitle', { number: this.mutableValue.stages?.length + 1 })
      newStage.agreements.push(this.$_.cloneDeep(contactTemplate))
      const result = this.$_.cloneDeep(this.mutableValue)
      result?.stages?.push(newStage)
      this.mutableValue = result
      this.createRules()
    },
    /**
     * Формируем правила валидации
     */
    createRules() {
      const that = this

      const getStageRules = (result, index) => {
        result[`stages[${index}]`] = {
          type: 'object',
          trigger: 'change',
          validator(rule, value, callback) {
            if (!value) {
              return callback(new Error(that.$t('Validate.Required')))
            }
            if (!value.title) {
              return callback(new Error(that.$t('Tenders.EnterStageTitle')))
            }
            if (value.editObject) {
              return callback(new Error(that.$t('Tenders.FinalEditTitleStage')))
            }
            const selectedAgreements = value.agreements?.filter(i => i.contactId || i.approverType === 'CONTACT_PERSON')
            if (!selectedAgreements?.length) {
              return callback(new Error(that.$t('Tenders.StageHasMinimumOneAgreement')))
            }
            if (value.agreements?.filter(i => i.edit)?.length) {
              return callback(new Error(that.$t('Tenders.FinishEditAgreements')))
            }
            if (value.type === 'QUORUM' && (!value.quorumCount || value.quorumCount > selectedAgreements?.length)) {
              return callback(new Error(that.$t('Tenders.QuorumCountMustBeLessAgreements')))
            }
            callback()
          }

        }
        return result
      }

      let result = {
        comment: {
          type: 'string',
          trigger: 'change',
          max: 1500,
          message: that.$t('Validate.maxLength', {number: 1500, type: that.$tc('Common.characters', 10) })
        },
      }
      this.mutableValue?.stages?.forEach((stage, stageIndex) => {
        result = getStageRules(result,  stageIndex)
      })
      this.rules = result
      this.$nextTick(() => {
        this.$refs.addAgreeingForm?.clearValidate()
      })
    },
  },
  computed: {
    menuList() {
      let opts =  [
        {
          text: this.$t('Common.Edit'),
          icon: 'edit',
          disabled: (index) => this.mutableValue.stages[index].activeStatus === 'DONE',
          click: (index) => {
            this.$refs[`stage-menu-${index}`][0].doClose()
            this.$nextTick(() => {
              this.editTitleStage(index)
            })
          }
        },
        {
          text: this.$t('Purchasing.Remove'),
          icon: 'delete',
          disabled: (index) => this.mutableValue?.stages?.[index]?.disable,
          click: (index) => {
            this.$refs[`stage-menu-${index}`][0].doClose()
            this.$nextTick(() => {
              this.deleteStage(index)
            })
          }
        }
      ]
      return opts
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    },
    managers: {
      get() {
        const result = []
        this.mutableValue?.stages?.forEach(stage => {
          const agreements = stage.agreements.map(i => i.contactId)
          const list = this.spr.managers
            .filter(sm => !agreements.includes(sm.contactId))

          let disableMessage = ''
          if (!list.length) {
            disableMessage = this.$t('Tenders.NoMoreContacts')
          }
          result.push(
            { list,
              disableMessage
            }
          )
        })
        return result
      }
    },
    agreements: {
      get() {
        const result = []
        this.mutableValue?.stages?.forEach(stage => {
          const commitStage = this.$_.cloneDeep(stage)

          result.push(
            commitStage.agreements.map(i => (
              {
                ...i,
                contactProps: i.approverType === 'CONTACT_PERSON'
                  ? { name: this.$t('Tenders.TenderContactPerson') }
                  : (this.spr.managers.find(ci => ci.contactId === i.contactId) || {})
              }
            ))
          )
        })
        return result
      }
    },
  },
  components: {
    UserIcon,
    MenuItem,
    StatusChip,
    CollapseBlock,
    StageAdditionalAgreementFormEdit
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.createRules()
        }
      }
    }
  },
  async mounted() {
    this.$store.dispatch('getContractNumberAndTariff')
      .then(res => {
        this.tariff = res?.tariff
      })
    this.spr.managers = await this.$store.dispatch('tenderContactPersons')
  },
  props: {
    disabled: {
      type: Boolean
    },
    value: {
      type: Object
    },
    mode: {
      type: String,
      validator: function (value) {
        const correct = ['default', 'automation'].indexOf(value) !== -1
        return correct
      },
      default: 'default',
    }
  },
}
</script>
<style scoped lang="scss">
.stage-title {
  display: grid;
  gap: 10px;
  padding: 5px 5px 5px 0;
  grid-template-columns: 1fr auto auto 30px;
  &.is-edit {
    grid-template-columns: 1fr;
  }
  &__edit-row {
    width: 100%;
    display: grid;
    gap: 4px;
  }
}
.stage-contact {
  display: grid;
  min-height: 40px;
  margin: 5px 0;
  grid-template-columns: 1fr 162px 120px;
}
.sFormItem.is-error .stage-title__edit {
  border-color: var(--color-error);
}
</style>
